import {RouteLocationNormalized, RouteLocationRaw} from 'vue-router'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

export function getRedirectToUpgradeIfNeverSubscribed(
  to: RouteLocationNormalized,
  hasHadSubscription: boolean | undefined,
  isOnboardingComplete = true,
  planId?: string | null,
  isSubscriptionRequired?: boolean,
): RouteLocationRaw | undefined {
  if(!isSubscriptionRequired || hasHadSubscription || planId || !isOnboardingComplete) {
    return undefined
  }
  const workspaceName = to.params.workspaceName as string
  if(!workspaceName) {
    return undefined
  }
  return {
    name: RouteName.WorkspaceUpgradePage,
    params: {
      workspaceName,
    },
  }
}
